import React from 'react';
import { Link } from 'react-router-dom';

interface PageHeaderProps {
  title: string;
  tagline?: string;
  back?: { to: string; label: string };
  actions?: React.ReactNode;
}

export default function PageHeader({ title, tagline, back, actions }: PageHeaderProps) {
  return (
    <header className="page-header">
      {back && (
        <Link to={back.to} className="page-header__back">
          ← {back.label}
        </Link>
      )}
      <div className="page-header__row">
        <div>
          <h1 className="page-header__title">{title}</h1>
          {tagline && <p className="page-header__tagline">{tagline}</p>}
        </div>
        {actions && <div className="page-header__actions">{actions}</div>}
      </div>
    </header>
  );
}
